export interface RelatedLink {
  href: string;
  label: string;
}

/** Small "Related" block placed below the main content of detail pages. */
export function RelatedLinks({ items, title = "Related", compact = false }: { items: RelatedLink[]; title?: string; compact?: boolean }) {
  if (!items?.length) return null;
  return (
    <section className="bhg-section related-section" aria-labelledby="related-heading">
      <div className="wrap">
        <h2
          id="related-heading"
          className="mono"
          style={{
            fontSize: 11,
            letterSpacing: "0.16em",
            textTransform: "uppercase",
            color: "rgba(0,47,167,0.45)",
            margin: 0,
          }}
        >
          {title}
        </h2>
        <ul className={compact ? "mt-4 flex list-none flex-wrap gap-x-6 gap-y-2 p-0" : "mt-4 list-none p-0"}>
          {items.slice(0, 5).map((l) => (
            <li key={l.href} style={{ padding: "6px 0" }}>
              <a
                href={l.href}
                className={compact ? "text-[13.5px] text-bleu" : undefined}
                style={compact ? undefined : {
                  fontFamily: '"IBM Plex Sans", "IBM Plex Sans Fallback", sans-serif',
                  fontWeight: 400,
                  fontSize: 16,
                  color: "#002FA7",
                  textDecoration: "underline",
                  textUnderlineOffset: "4px",
                }}
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
